import isEmptyObject from './isEmptyObject';

const emptyRecord: Readonly<Record<PropertyKey, never>> = Object.freeze(
  Object.create(null),
);

type ShouldBePartial<Key extends PropertyKey> =
  PropertyKey extends infer KeyCategory
    ? KeyCategory extends Key
      ? true
      : never
    : never;

export type ReadonlyRecord<K extends PropertyKey, V> = Readonly<
  ShouldBePartial<K> extends true ? Partial<Record<K, V>> : Record<K, V>
>;

export default function createReadonlyRecord<
  T extends Readonly<Partial<Record<PropertyKey, unknown>>>,
>(values?: T): Readonly<T>;
export default function createReadonlyRecord<K extends PropertyKey, V>(
  values?: Readonly<Record<K, V>>,
): ReadonlyRecord<K, V>;
export default function createReadonlyRecord<K extends PropertyKey, V>(
  values?: Readonly<Record<K, V>>,
): ReadonlyRecord<K, V> {
  let record;
  if (
    values == null ||
    isEmptyObject(
      (record = Object.freeze(Object.assign(Object.create(null), values))),
    )
  ) {
    record = emptyRecord;
  }
  return record;
}
